/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ApproveRejectIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Approve Reject',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M24 12a12 12 0 0 0-12 12 11.831 11.831 0 0 0 12 11.8A11.662 11.662 0 0 0 35.8 24 11.831 11.831 0 0 0 24 12Zm7.242 7.907-7.224 9.434a1.206 1.206 0 0 1-.875.461h-.073a1.2 1.2 0 0 1-.849-.351l-4.837-4.847a1.2 1.2 0 0 1 0-1.7l1.327-1.325a1.2 1.2 0 0 1 1.7 0l2.4 2.4L27.89 17.3a1.2 1.2 0 0 1 1.686-.21l1.455 1.133a1.2 1.2 0 0 1 .211 1.684Z"
    />
    <path
      d="M11.521 14H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h11.26a15.9 15.9 0 0 1 7.055-1.965A11.818 11.818 0 0 0 12 .2 11.662 11.662 0 0 0 .2 12a11.819 11.819 0 0 0 7.834 11.315A15.921 15.921 0 0 1 11.521 14Z"
    />
  </svg>`;
};
